exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ticket-group-title-bulk[data-v-badd875a]{color:#2c3e50;font-weight:700;font-size:1.1rem;padding:.5rem 0;margin-bottom:.7rem;margin-top:2rem!important}.ticket-group-title-bulk[data-v-badd875a]:first-child{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-badd875a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/RegistrationCategories/Tickets/Group.vue
// module id = 2460
// module chunks = 1